@charset "UTF-8";

/* src/app/custom-chip/custom-chip.component.scss */
:host {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.custom-chip-set {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 0;
}
::ng-deep .custom-chip-set .mat-mdc-chip.mat-mdc-chip-row,
::ng-deep .custom-chip-set .mat-mdc-chip {
  --mdc-chip-container-height: 28px;
  --mdc-chip-label-text-size: 12px;
  --mdc-chip-label-text-weight: 500;
  --mdc-chip-label-text-color: #484b59;
  background-color: #F4F9FA !important;
  border: 1px solid rgba(213, 222, 230, 0.4) !important;
  border-radius: 20px !important;
  padding: 2px 8px !important;
  height: 28px !important;
  min-height: 28px !important;
  display: inline-flex !important;
  align-items: center !important;
  gap: 4px !important;
  cursor: default;
  box-shadow: none !important;
}
::ng-deep .custom-chip-set .mat-mdc-chip.mat-mdc-chip-row .mdc-evolution-chip__action--primary::before,
::ng-deep .custom-chip-set .mat-mdc-chip.mat-mdc-chip-row .mat-mdc-chip-focus-overlay,
::ng-deep .custom-chip-set .mat-mdc-chip .mdc-evolution-chip__action--primary::before,
::ng-deep .custom-chip-set .mat-mdc-chip .mat-mdc-chip-focus-overlay {
  display: none !important;
}
::ng-deep .custom-chip-set .mat-mdc-chip.mat-mdc-chip-row:hover,
::ng-deep .custom-chip-set .mat-mdc-chip:hover {
  border-color: #b0b4c0 !important;
}
::ng-deep .custom-chip-set .mat-mdc-chip.mat-mdc-chip-row.chip-excluded,
::ng-deep .custom-chip-set .mat-mdc-chip.chip-excluded {
  background-color: #fff5f5 !important;
  border-color: #f5c6c2 !important;
}
::ng-deep .custom-chip-set .mat-mdc-chip.mat-mdc-chip-row.chip-excluded .mdc-evolution-chip__text-label,
::ng-deep .custom-chip-set .mat-mdc-chip.mat-mdc-chip-row.chip-excluded .chip-label,
::ng-deep .custom-chip-set .mat-mdc-chip.chip-excluded .mdc-evolution-chip__text-label,
::ng-deep .custom-chip-set .mat-mdc-chip.chip-excluded .chip-label {
  color: #c62828 !important;
}
::ng-deep .custom-chip-set .mat-mdc-chip.mat-mdc-chip-row.chip-excluded .chip-icon-left,
::ng-deep .custom-chip-set .mat-mdc-chip.chip-excluded .chip-icon-left {
  color: #e53935 !important;
}
::ng-deep .custom-chip-set .mat-mdc-chip.ai-suggested-chip {
  border: 1px solid rgba(213, 222, 230, 0.4);
  background-color: #FEF8FA !important;
}
::ng-deep .custom-chip-set .mat-mdc-chip.ai-suggested-chip .chip-icon-left {
  color: #D74B92 !important;
}
::ng-deep .custom-chip-set .mat-mdc-chip.ai-suggested-chip .chip-remove-btn {
  color: #D74B92 !important;
}
::ng-deep .custom-chip-set .mat-mdc-chip.ai-suggested-chip .chip-label {
  font-weight: 400 !important;
}
::ng-deep .custom-chip-set .mat-mdc-chip-remove,
::ng-deep .custom-chip-set .mat-mdc-chip-trailing-icon {
  padding: 0 !important;
  margin: 0 !important;
  width: auto !important;
  height: auto !important;
  opacity: 1 !important;
}
.chip-label {
  font-size: 12px;
  font-weight: 500;
  color: #484b59;
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.5;
  margin-right: 8px;
}
.chip-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  line-height: 1;
  flex-shrink: 0;
  cursor: pointer;
  transition: color 0.15s ease, transform 0.1s ease;
}
.chip-icon:hover {
  transform: scale(1.15);
}
.chip-icon-left {
  color: #2E93A1;
}
.chip-icon-left:hover {
  color: #e53935;
}
.chip-icon-left.icon-excluded {
  color: #e53935;
}
.chip-remove-btn {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  background: none !important;
  border: none !important;
  padding: 0 !important;
  margin: 0 !important;
  cursor: pointer;
  font-size: 14px;
  color: #2E93A1 !important;
  line-height: 1;
  transition: color 0.15s ease, transform 0.1s ease;
}
.chip-remove-btn:hover {
  color: #484b59;
  transform: scale(1.15);
}
::ng-deep .custom-chip-set .mat-mdc-chip.chip-suggestion {
  background-color: #ffffff !important;
  border: 1px solid #d0d3dc !important;
  cursor: pointer !important;
}
::ng-deep .custom-chip-set .mat-mdc-chip.chip-suggestion:hover {
  background-color: #f5f5f5 !important;
  border-color: #b0b4c0 !important;
}
::ng-deep .custom-chip-set .mat-mdc-chip.chip-suggestion .chip-label {
  color: #484b59;
}
.chip-icon-plus {
  color: #e91e8c;
  font-size: 11px;
  font-weight: 600;
}
.chip-mandatory {
  border-color: #e24e7f !important;
  background-color: rgba(226, 78, 127, 0.08) !important;
}
.icon-mandatory svg path {
  fill: #e24e7f;
}
.chip-icon {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
}
.chip-icon:hover svg {
  opacity: 0.7;
}
/*# sourceMappingURL=custom-chip.component-VXO4MD5H.css.map */
